module.exports = "<p>\n  email-templates-labels works!\n</p>\n"